import React from 'react';

import {useSelector, shallowEqual} from 'react-redux';

import {Feature} from 'components/feature';
import {REFERER_OFFER} from 'constants/analytics/mentionMe';

import {PRESCRIPTION_STATUS} from 'constants/success';
import {MentionMeBannerV2} from 'desktop/components/mentionMe/mentionMeBannerV2/mentionMeBannerV2';
import {ApplicationStoreType} from 'desktop/store';
import {useCheckLuxuryItem} from 'hooks/useCheckLuxuryItem/useCheckLuxuryItem';
import {flags} from 'libs/rollout';
import {getIsAllItemsOfOrderUpdated} from 'libs/success/helpers/helpers';

import {SuccessPageRewardsBannerV2} from '../../components/successPageRewardsBanner/successPageRewardsBannerV2/successPageRewardsBannerV2';
import {getPrescriptionStatus} from '../../selectorsV2/prescription';
import {getOrderItems} from '../../store/selectors/orderStatus/orderStatus';
import {ShopWithConfidence} from '../shopWithConfidence/shopWithConfidence';

const MENTION_ME_BANNER_PARAMS = {
    implementation: 'popup',
    locale: 'en_GB',
    situation: 'postpurchase',
};

/**
 * The right side for CL TYP
 */
export const SuccessRightSide = () => {
    const {items, originalStatus} = useSelector(
        (store: ApplicationStoreType) => ({
            items: getOrderItems(store),
            originalStatus: getPrescriptionStatus(store),
        }),
        shallowEqual,
    );
    const isLuxuryEnabled = useCheckLuxuryItem(flags.dLuxurySpecialExperience.isEnabled());
    const isVerification =
        getIsAllItemsOfOrderUpdated(items) || originalStatus === PRESCRIPTION_STATUS.UPLOAD;

    return (
        <>
            {isVerification ? (
                <>
                    {!isLuxuryEnabled && <SuccessPageRewardsBannerV2 />}
                    <Feature flag="typMentionMeBanner" platform="desktop">
                        <MentionMeBannerV2
                            integratingType={REFERER_OFFER}
                            params={MENTION_ME_BANNER_PARAMS}
                        />
                    </Feature>
                </>
            ) : (
                <ShopWithConfidence />
            )}
        </>
    );
};
